// extracted by mini-css-extract-plugin
module.exports = {"item":"FollowingItemList_item__2BFYk","sending":"FollowingItemList_sending__3PkrB"};